import { Grid, Typography } from "@mui/material";
import React from "react";
import Dashboard from "../CallCenter/patients/Dashboard";
import BeautyDashboard from "./Procedure/BeautyDashboard";

const BeautyIndex = () => {
  return (
    <Grid container maxWidth="xl" mb={3}>
      <Grid container gap={1} mt={2} justifyContent={"center"}>
        <Grid item xs={12} lg={12}>
          <BeautyDashboard />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BeautyIndex;
